import { Component, Input } from '@angular/core';
import { AuditModel, AuditSearchModel } from 'app/models/audit.model';
import { NexusComponent } from '../nexus/nexus.component';
import { AuditHistoryService } from 'app/core/services/audit-history.service';
import { clockArrowRotateIcon } from '@progress/kendo-svg-icons';

@Component({
  standalone: false,
  selector: 'audit-history',
  templateUrl: './audit-history.component.html',
  styleUrls: ['./audit-history.component.scss']
})
export class AuditHistoryComponent extends NexusComponent{
  isDialogOpen = false;
  clockArrowRotateIcon=clockArrowRotateIcon
  @Input() public search: AuditSearchModel;
  public model: Array<AuditModel> = new Array<AuditModel>();
  constructor(private service: AuditHistoryService) {
    super();
  }

  ngOnInit(): void {

  }

  load_audit_history(){
    if (this.search) {
      this.StartSpinner('nexus-audit');
      this.service.SearchAudit(this.search).subscribe(data => {
        this.model = data;
        this.StopSpinner('nexus-audit');
      });
    } else{
      this.model = [];
    }
  }

  public getKeys(meta: Map<string, string>)
  {
    return Object.keys(meta);
  }

  public replaceUnderscore(str: string) {
    return str?.replace(/_/g, ' ').replace(/-/g, ' ');
  }
  public replaceHTMLTags(str: string) {
    return str?.replace(/<[^>]*>/g, '');
  }


  openDialog(): void {
    this.isDialogOpen = true;
    this.load_audit_history();
  }

  closeDialog(): void {
    this.isDialogOpen = false;
    this.model = [];
  }
}


